module.exports = __webpack_public_path__ + "static/media/Bell List.25f87c76.png";